import React, { useContext } from 'react';
import { OverlayTrigger, Popover, PopoverContent, PopoverTitle } from 'react-bootstrap';
import { DragServiceGable } from '../../services/CabinetService/DragServiceGable';
import { EditorContext } from '../EditorCommon/EditorContext';
import { InteriorDragContext } from './InteriorImageDragContext';

export function GableMover(props: {

}) {

    const ec = useContext(EditorContext);
    const dragContext = useContext(InteriorDragContext);

    if (!dragContext.info?.item) {
        return null;
    }

    const itemIndex = dragContext.info.item.index;

    const product = ec.cabinetService.interior.getProduct(dragContext.info.item.productId);
    if (!DragServiceGable.acceptable(product.productSubGroup)) {
        return null;
    }

    function moveItem(evt: React.MouseEvent, direction: number) {
        evt.preventDefault();
        evt.stopPropagation();
        const distance = evt.ctrlKey
            ? 1
            : 10;
        ec.cabinetService.interior.moveGable(itemIndex, direction * distance);
    }

    const helpOverlay = (
        <Popover id="gableMoveHelp" >
            <PopoverTitle style={{ textAlign: "center" }}>
                {ec.translator("interior editor move item", "Flyt")}
            </PopoverTitle>
            <PopoverContent style={{ whiteSpace: "pre-line" }}>
                {ec.translator("interior editor move item help",
                    "Klik på pilene for at flytte varen.\nHold Ctrl nede for at flytte 1 mm ad gangen.")}
            </PopoverContent>
        </Popover>
    );

    return (
        <OverlayTrigger trigger={["hover", "focus"]}
            placement="bottom"
            overlay={helpOverlay}
            transition={false}
        >
                <ul className="list-group list-group-horizontal" >
                    <li className="list-group-item list-group-item-action "
                        onClick={(evt) => moveItem(evt, -1)}
                        title={ec.translator("interior editor move item title left", "Flyt varen til venstre.")}
                    >
                        &laquo;
                    </li>
                    <li className="list-group-item expandable"
                    >
                        {ec.translator("interior editor move item", "Flyt")}
                    </li>
                    <li className="list-group-item list-group-item-action "
                        onClick={(evt) => moveItem(evt, +1)}
                        title={ec.translator("interior editor move item title right", "Flyt varen til højre.")}
                    >
                        &raquo;
                    </li>
                </ul>

        </OverlayTrigger>
    );

}
